export const InputType = {
	TextInput: 'textInput',
	Select: 'select',
	StatesSelect: 'statesSelect',
	UneditableInput: 'uneditableInput',
};
